// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"4fa85d74","703":"23f8227f"}[chunkId] + ".chunk.js";
};